import { render, staticRenderFns } from "./jordienp.vue?vue&type=template&id=35b7cfb8&"
import script from "./jordienp.vue?vue&type=script&lang=js&"
export * from "./jordienp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports